export const NAME = 'chat';

export const ALLIANCE_DOCUMENT_TYPE = 'alliance';
export const CREDIT_DOCUMENT_TYPE = 'credit';
export const FINANCIER_USER_TYPE = 0;
export const INSTALLER_USER_TYPE = 1;
